/* @pareto-engineering/generator-front 0.2.3 */
import * as React from 'react';
import { useReducer } from 'react';
import PropTypes from 'prop-types';
import useTheme from "./useTheme";

// Package-level Imports
import Context from "./Context";

// Component-level imports

// Helper Definitions

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
const AppContextProvider = ({
  children,
  initialTheme,
  config,
  initialState
  // ...otherProps
}) => {
  const theme = useTheme(initialTheme);
  const [state, dispatch] = useReducer(reducer, initialState);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      state,
      dispatch,
      ...config,
      ...theme
    }
  }, children);
};
AppContextProvider.propTypes = {
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * The initial theme for the website. If undefined, fallbacks on system preference.
   */
  initialTheme: PropTypes.string,
  /**
   * A dictionnary containing settings and preferences to be used application-wide
   */
  config: PropTypes.shape({
    APP: PropTypes.shape({
      NAME: PropTypes.string.isRequired,
      CANONICAL: PropTypes.string.isRequired,
      SUPPORT_EMAIL: PropTypes.string,
      TITLE_SUFFIX: PropTypes.string
    }),
    SOCIAL: PropTypes.shape({
      FACEBOOK: PropTypes.string,
      INSTAGRAM: PropTypes.string,
      YOUTUBE: PropTypes.string
    }),
    CONSTANTS: PropTypes.shape({})
  }).isRequired,
  /**
   * Application context initial state
   */
  initialState: PropTypes.objectOf(PropTypes.string)
};
AppContextProvider.defaultProps = {
  initialState: {}
};
export default AppContextProvider;